<div class="PGPhone input-group">
        <!--<div class="input-group-text" ngbDropdown>
                <span ngbDropdownToggle>{{valuePrefix}}</span>
                <div ngbDropdownMenu>
                        <div *ngFor="let option of prefixOptions" class="dropdown-item" (click)="setValuePrefix(option.value)">{{option.text}}</div>
                </div>
        </div>
        <input [id]="fieldId" class="form-control" [disabled]="readonly" [required]="required" [(ngModel)]="valueNumber" (ngModelChange)="onValueNumberChange()"/> -->  
        <input [id]="fieldId" class="form-control" [disabled]="readonly" [required]="required" [(ngModel)]="value" (ngModelChange)="onValueChange()"/>
</div>